<div style="height: 100%" #viewerContainer>
  @if (isImage) {
  <pinch-zoom style="height: 100%">
    <img [src]="this.localUrl" (load)="hideLoader = true" />
  </pinch-zoom>
  } @if (isVideo) {
  <video preload="metadata" style="height: 100%" controls>
    <source [src]="getFileVideoSource()" type="video/mp4" />
  </video>
  }
</div>
